import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Sidebar from './sidebar';
import Overlay from '../components/overlay';
import Header from './header';
import { get_timesheets_report, edit_punch, delete_punch, add_punch } from '../actions/index';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import PunchReport from './timesheets_report';

class Timesheets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      from_selectedDay: undefined,
      to_selectedDay: undefined,
      report_day_from: '',
      report_day_to: '',
      report_created: '',
      showEditModal: false,
      showDeleteModal: false,
      edit_punch_in: '',
      edit_punch_out: '',
      edit_date: '',
      edit_punchcardid: '',
      edit_employee_id: ''
    }


    this.openEditModal = this.openEditModal.bind(this);
    this.closeEditModal = this.closeEditModal.bind(this);
    this.handleEditPunch = this.handleEditPunch.bind(this);

    this.openDeleteModal = this.openDeleteModal.bind(this);
    this.closeDeleteModal = this.closeDeleteModal.bind(this);
    this.handleDeletePunch = this.handleDeletePunch.bind(this);
  }

  componentWillMount() {
    //console.log(window.store.getState());
  }

  // Functions for editing a punch time
  // Close the edit modal
  closeEditModal() {
    this.setState({ showEditModal: false });
  }

  // Open the edit modal
  openEditModal(punchcardid, employee_id, date, punchin, punchout) {
    if (!date) {
      date = moment().format('YYYY-MM-DD');
    }

    this.setState({ edit_punchcardid: punchcardid, edit_employee_id: employee_id, edit_date: date, edit_punch_in: punchin, edit_punch_out: punchout });
    this.setState({ showEditModal: true });
  }

  // When the user
  handleEditChange(employee_id, date, punch_in, punch_out) {
    this.setState({ edit_employee_id: employee_id, edit_date: date, edit_punch_in: punch_in, edit_punch_out: punch_out });
  }

  // User has clicked ok to edit value, send punch time to the reducers
  handleEditPunch() {
    var report_date_from = moment(this.state.from_selectedDay).format('YYYY-MM-DD');
    var report_date_to = moment(this.state.to_selectedDay).format('YYYY-MM-DD');

    if (this.state.edit_punchcardid !== '') {
      this.props.edit_punch(this.state.edit_punchcardid, this.state.edit_employee_id, this.state.edit_date, this.state.edit_punch_in, this.state.edit_punch_out, report_date_from, report_date_to);
    } else {
      this.props.add_punch(this.state.edit_employee_id, this.state.edit_date, this.state.edit_punch_in, this.state.edit_punch_out, report_date_from, report_date_to);
    }

    this.closeEditModal();
  }

  // Functions for deleting a punch time
  // Close the delete modal
  closeDeleteModal() {
    this.setState({ showDeleteModal: false });
  }

  // Open the delete modal
  openDeleteModal(punchcardid) {
    this.setState({ edit_punchcardid: punchcardid });
    this.setState({ showDeleteModal: true });
  }

  // User has clicked ok to delete punch, send punchcard id to the reducers
  handleDeletePunch() {
    var report_date_from = moment(this.state.from_selectedDay).format('YYYY-MM-DD');
    var report_date_to = moment(this.state.to_selectedDay).format('YYYY-MM-DD');

    this.props.delete_punch(this.state.edit_punchcardid, report_date_from, report_date_to);
    this.closeDeleteModal();
  }

  from_handleDayChange = (from_selectedDay, modifiers) => {
    this.setState({
      from_selectedDay,
      from_isDisabled: modifiers.disabled,
    });
  }

  to_handleDayChange = (to_selectedDay, modifiers) => {
    this.setState({
      to_selectedDay,
      to_isDisabled: modifiers.disabled,
    });
  }

  handleReport = () => {
    this.setState({
      report_day_from: moment(this.state.from_selectedDay).format('DD/MM/YYYY'),
      report_day_to: moment(this.state.to_selectedDay).format('DD/MM/YYYY'),
      report_created: Date()
    });
    var report_date_from = moment(this.state.from_selectedDay).format('YYYY-MM-DD');
    var report_date_to = moment(this.state.to_selectedDay).format('YYYY-MM-DD');

    // send report_date to action
    this.props.get_timesheets_report(report_date_from, report_date_to);
  }

  renderSelect() {
    if ( (this.props.restaurant.employees !== undefined) && (this.props.restaurant.employees.length > 0) ) {
      var items = this.props.restaurant.employees;

      return items.map( (item, index) => {
        return(
          <option key={item.employee_id} value={item.employee_id}>{item.employee_name}</option>
        );
      });
    }
  }

  render() {
    const DAY_FORMAT = 'DD/MM/YYYY';
    const { from_selectedDay, to_selectedDay } = this.state;
    const from_formattedDay = from_selectedDay
      ? moment(from_selectedDay).format(DAY_FORMAT)
      : '';
    const to_formattedDay = to_selectedDay
      ? moment(to_selectedDay).format(DAY_FORMAT)
      : '';

    const dayPickerProps = {
      todayButton: 'Go to Today',
      disabledDays: {
        daysOfWeek: [0, 6],
      },
      enableOutsideDays: true,
      modifiers: {
        monday: { daysOfWeek: [1] },
      },
    };

    // If the server has yet to send back report items, then show the loading page
    if (this.props.reports.loading) {
      return (
        <div>
          <Overlay />
          <Sidebar />
          <Header />
          <div className="site-content">
            <nav className="navbar navbar-light bg-white navbar-bottom-line b-a mb-1 p-1">
              <div className="col-md-10 mb-2 mb-md-0">
                <h5>Choose a day and click Load Report.</h5>
                <select>
                  <option value="all">All</option>
                  {this.renderSelect()}
                </select>
                &nbsp;&nbsp;
                <b>From:</b>&nbsp;
              <DayPickerInput
                value={from_formattedDay}
                onDayChange={this.from_handleDayChange}
                format={DAY_FORMAT}
                placeholder={`E.g. ${moment().locale('en').format(DAY_FORMAT)}`}
                dayPickerProps={dayPickerProps}
              />
              &nbsp;&nbsp;
              <b>To:</b>&nbsp;
              <DayPickerInput
                value={to_formattedDay}
                onDayChange={this.to_handleDayChange}
                format={DAY_FORMAT}
                placeholder={`E.g. ${moment().locale('en').format(DAY_FORMAT)}`}
                dayPickerProps={dayPickerProps}
              />
                &nbsp;
                <input type="button" className="btn btn-primary b-a" onClick={event => this.handleReport()} value="Load Report" />
              </div>
            </nav>
            <div className="content-area py-1">
              <div className="container-fluid">
                Loading...
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <Overlay />
        <Sidebar />
        <Header />
        <div className="site-content">
          <nav className="navbar navbar-light bg-white navbar-bottom-line b-a mb-1 p-1">
            <div className="col-md-10 mb-2 mb-md-0">
              <h5>Choose a day to get all punches from that day to today.</h5>
              <select>
                <option value="all">All</option>
                {this.renderSelect()}
              </select>
              &nbsp;&nbsp;
              <b>From:</b>&nbsp;
              <DayPickerInput
                value={from_formattedDay}
                onDayChange={this.from_handleDayChange}
                format={DAY_FORMAT}
                placeholder={`E.g. ${moment().locale('en').format(DAY_FORMAT)}`}
                dayPickerProps={dayPickerProps}
              />
              &nbsp;&nbsp;
              <b>To:</b>&nbsp;
              <DayPickerInput
                value={to_formattedDay}
                onDayChange={this.to_handleDayChange}
                format={DAY_FORMAT}
                placeholder={`E.g. ${moment().locale('en').format(DAY_FORMAT)}`}
                dayPickerProps={dayPickerProps}
              />
              &nbsp;
              <input type="button" className="btn btn-primary b-a" onClick={event => this.handleReport()} value="Load Report" />
            </div>
          </nav>
          <div className="content-area py-1">
            <div className="container-fluid">
              <PunchReport onOpenEditModal={this.openEditModal} onOpenDeleteModal={this.openDeleteModal} report_created={this.state.report_created} report_day_from={this.state.report_day_from} report_day_to={this.state.report_day_to} />
            </div>
          </div>
        </div>

        <Modal show={this.state.showEditModal} onHide={this.closeEditModal}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Punch Times</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="form-group">
                Employee: <br /><select value={this.state.edit_employee_id} onChange={event => this.handleEditChange(event.target.value, this.state.edit_date, this.state.edit_punch_in, this.state.edit_punch_out)}>{this.renderSelect()}</select><br />
                Date: <input type="text" autoFocus className="form-control" onChange={event => this.handleEditChange(this.state.edit_employee_id, event.target.value, this.state.edit_punch_in, this.state.edit_punch_out)} value={this.state.edit_date} />
                Punch In: <input type="text" className="form-control" onChange={event => this.handleEditChange(this.state.edit_employee_id, this.state.edit_date, event.target.value, this.state.edit_punch_out)} value={this.state.edit_punch_in} />
                Punch Out: <input type="text" className="form-control" onChange={event => this.handleEditChange(this.state.edit_employee_id, this.state.edit_date, this.state.edit_punch_in, event.target.value)} value={this.state.edit_punch_out} />
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-secondary" onClick={this.closeEditModal}>Close</button>&nbsp;
            <button type="button" className="btn btn-primary" onClick={this.handleEditPunch}>OK</button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.showDeleteModal} onHide={this.closeDeleteModal}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Punch Time</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>Are you sure you want to delete this punch time?</div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-secondary" onClick={this.closeDeleteModal}>Cancel</button>&nbsp;
            <button type="button" className="btn btn-primary" onClick={this.handleDeletePunch}>OK</button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps({ reports, punch, restaurant }) {
  return { reports, punch, restaurant };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { get_timesheets_report, edit_punch, delete_punch, add_punch }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Timesheets);



// WEBPACK FOOTER //
// ./src/containers/timesheets.js